module.exports = __webpack_public_path__ + "static/media/mood-board-header.523f6a5e.png";